import { number, numberMax, numberMin, ValidationError, Validator } from '@/entities/validation';
import { ScoreTriggerEditable } from '@/ui/DTO';

export const validate: Validator<ScoreTriggerEditable|null> = scoreTrigger => {
  if (!scoreTrigger) {
    return [];
  }

  const result = [] as ValidationError[];

  if (scoreTrigger.operator === 'between' || scoreTrigger.operator === '>') {
    result.push(
      ...number(scoreTrigger.from, true, 'scoreTrigger.from'),
      ...numberMin(scoreTrigger.from, 0, 'scoreTrigger.from'),
      ...numberMax(scoreTrigger.from, 100, 'scoreTrigger.from'),
    );
  }

  if (scoreTrigger.operator === 'between' || scoreTrigger.operator === '<') {
    result.push(
      ...number(scoreTrigger.to, true, 'scoreTrigger.to'),
      ...numberMin(scoreTrigger.to, 0, 'scoreTrigger.to'),
      ...numberMax(scoreTrigger.to, 100, 'scoreTrigger.to'),
    );
  }

  if (result.length) {
    return result;
  }

  if (scoreTrigger.operator === 'between' && parseFloat(scoreTrigger.from) >= parseFloat(scoreTrigger.to)) {
    result.push({
      field: 'scoreTrigger',
      type: 'unknown',
      parameters: [],
    });
  }

  return result;
};
